var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLightbulb = function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lightbulb_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".lightbulb_svg__st1{fill:#00ff52}")), /*#__PURE__*/React.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "lightbulb_svg__st1",
    cx: 275.17,
    cy: 216.74,
    r: 132.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.17 358.89c-78.38 0-142.15-63.77-142.15-142.15S196.79 74.59 275.17 74.59s142.15 63.77 142.15 142.15-63.77 142.15-142.15 142.15zm0-264.29c-67.35 0-122.15 54.8-122.15 122.15S207.81 338.9 275.17 338.9s122.15-54.79 122.15-122.15S342.53 94.6 275.17 94.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "lightbulb_svg__st1",
    d: "M299.02 471.75h-47.68c-21.71 0-39.31-17.6-39.31-39.31v-96.48h126.3v96.48c-.01 21.71-17.61 39.31-39.31 39.31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.01 481.75h-47.68c-27.19 0-49.31-22.12-49.31-49.31v-96.48c0-5.52 4.48-10 10-10h126.3c5.52 0 10 4.48 10 10v96.48c0 27.19-22.12 49.31-49.31 49.31zm-76.98-135.78v86.48c0 16.16 13.15 29.31 29.31 29.31h47.68c16.16 0 29.31-13.15 29.31-29.31v-86.48h-106.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 388.51H217.22c-5.52 0-10-4.48-10-10s4.48-10 10-10H326.9c5.52 0 10 4.48 10 10s-4.47 10-10 10zM326.9 427.1H217.22c-5.52 0-10-4.48-10-10s4.48-10 10-10H326.9c5.52 0 10 4.48 10 10s-4.47 10-10 10zM333.92 204.33h-47.45c-5.52 0-10-4.48-10-10s4.48-10 10-10h47.45c5.52 0 10 4.48 10 10s-4.48 10-10 10z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M333.92 204.33c-3.56 0-6.94-1.91-8.74-5.14-1.07-1.89-27.16-46.84-77.13-31.16-5.27 1.65-10.88-1.28-12.53-6.55-1.65-5.27 1.28-10.88 6.55-12.53 34.37-10.78 60 .89 75.45 12.59 2.29 1.73 4.42 3.51 6.4 5.3v-19.95c0-5.52 4.48-10 10-10s10 4.48 10 10v47.45c0 4.56-3.08 8.53-7.49 9.68-.84.21-1.68.31-2.51.31zM263.88 244.4h-47.45c-5.52 0-10-4.48-10-10s4.48-10 10-10h47.45c5.52 0 10 4.48 10 10s-4.48 10-10 10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.43 291.85c-5.52 0-10-4.48-10-10V234.4a10.003 10.003 0 0 1 18.74-4.87c1.07 1.89 27.16 46.84 77.13 31.16 5.27-1.65 10.88 1.28 12.53 6.55 1.65 5.27-1.28 10.88-6.55 12.53-34.36 10.78-60-.89-75.45-12.59a94.371 94.371 0 0 1-6.4-5.3v19.95c0 5.54-4.48 10.02-10 10.02z"
  })));
};

export default SvgLightbulb;